// @ts-expect-error TODO
import {CryptoJS} from "node-cryptojs-aes";

// The salt is constant so URLs don't change randomly, breaking caches.
const salt = CryptoJS.enc.Hex.parse("ea73535ea7424e0e");

/**
 * File URLs are retrieved using a "key" that consists of an access token encrypted using a key (e.g. the file hash in
 * the case of image annotations; the original PDF's URL in the case of OCR).
 *
 * That way we avoid having plain access tokens in the URLs.
 *
 * @param {string} accessToken
 * @param {string} encryptionKey
 * @return {string} Empty string if anything goes wrong.
 */
export const getFileKey = (accessToken: string, encryptionKey: string): string => {
	let encrypted = "";
	try {
		encrypted = CryptoJS.AES.encrypt(
			accessToken, encryptionKey, {
				// This overrides the generation of random salt values
				// @ts-expect-error TS(7006) FIXME: Parameter 'password' implicitly has an 'any' type.
				kdf: {execute: (password, keySize, ivSize) => CryptoJS.kdf.OpenSSL.execute(password, keySize, ivSize, salt)}
			}).toString();
	} catch (e) {
		console.error(`PN getFileKey(): Error while encrypting access token (encryption key: ${encryptionKey}`, e);
	}
	return encodeURIComponent(encrypted);
};

export default {
	getFileKey
};
